import * as React from 'react';
import Icons from '../../Icons';
import Modal from "react-responsive-modal";
import {useState} from "react";

interface RollbackActionProps {
  onRollback: () => void
}


export const RollbackAction = (props: RollbackActionProps) => {
  const [showRevertModal, setShowModalRevert] = useState<boolean>(false);
  return (
      <>
        <Modal open={showRevertModal} onClose={() => {setShowModalRevert(!showRevertModal)}} center
                     classNames={{overlay: 'bootstrap-container', modal: ' customModal',
                       closeButton: ' closeButton'}}>
          <div className="p-2">
            <p className={'text-center font18 bold'}>Vous allez annuler la dernière action réalisée sur votre fichier. Souhaitez-vous poursuivre ?</p>
            <button title="Annuler" onClick={() => setShowModalRevert(!showRevertModal)}
                    className="border border-dark bold bg-white cursor-pointer btnCancelModal  py-2 px-3 float-left">
              <Icons icon="cancel" size={30} color="black" className="mr-2"/> Annuler
            </button>
            <button title="Valider" onClick={props.onRollback}
                    className={'border border-dark bold bg-white ml-0 ml-md-5 cursor-pointer btnValidateModal py-2 px-3 float-right'}>
              <Icons icon="check_circle" size={30} color="black" className="mr-2"/> Confirmer
            </button>
          </div>
        </Modal>
        <button className={'batAutoBtnEditor  mb-2 d-flex align-items-center'}  onClick={() => setShowModalRevert(true)}>
          <Icons icon="ic-revert" size={25} color="black" className="" />
          <div className={"my-2 pl-2"}>Annuler ma dernière action</div>
        </button>
      </>
  );
}